import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const TopL2Protocols = () => {
  const [defiData, setDefiData] = useState(null);
  const [protocolTotalChanges, setProtocolTotalChanges] = useState({});
  const [selectedPeriod, setSelectedPeriod] = useState('day');
  const [loading, setLoading] = useState(true);  

  useEffect(() => {
    const fetchData = async (retryCount = 0) => {
      try {
        const cachedData = sessionStorage.getItem(`l2-data-${selectedPeriod}`);

        if (cachedData) {
          const parsedData = JSON.parse(cachedData);
          setDefiData(parsedData.defiData);
          setProtocolTotalChanges(parsedData.protocolTotalChanges);
          setLoading(false);
          return; // Exit early if cache is available
        }

        setLoading(true); // Set loading to true before fetch starts
        const response = await axios.get(`/api/l2?period=${selectedPeriod}`);
        
        // Save the response in sessionStorage
        sessionStorage.setItem(
          `l2-data-${selectedPeriod}`,
          JSON.stringify({
            defiData: response.data.defiData,
            protocolTotalChanges: response.data.protocolTotalChanges,
          })
        );

        setDefiData(response.data.defiData);
        setProtocolTotalChanges(response.data.protocolTotalChanges);
        setLoading(false); // Set loading to false after fetch ends
      } catch (error) {
        //console.error("Error fetching DeFi data:", error);
        if (retryCount < 3) {
          setTimeout(() => fetchData(retryCount + 1), 200);
        } else {
          setLoading(false); // Ensure loading is turned off even on failure
        }
      }
    };

    fetchData();
  }, [selectedPeriod]);

  const toLocaleString = (num) => {
    return Number(num || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const getTopProtocols = () => {
    if (defiData && defiData.protocolTotals) {
      return Object.keys(defiData.protocolTotals)
        .sort((a, b) => defiData.protocolTotals[b].total_assets[0] - defiData.protocolTotals[a].total_assets[0])
        .slice(0, 4);
    }
    return [];
  }

  if (loading) {
    return (
      <div className="py-4  border-t w-full" style={{borderColor: 'var(--border-color)', height: "200px"}}>     
      </div>
    )
  }

  return (
    <div className="py-4  border-t w-full" style={{borderColor: 'var(--border-color)',}}>
      {defiData && defiData.protocolTotals
        ? getTopProtocols().map((protocol) => {
            const change = protocolTotalChanges[protocol];
            const isIncrease = change > 0;
            const textColor = isIncrease ? "text-green-500" : "text-red-500";
            return (
              <Link to="/l2data" key={protocol}>
                <div className="flex justify-between compatible-link w-full">
                  <h3 className="flex-grow">{protocol}</h3>
                  <p className={textColor + " flex-shrink-0"}>◊{toLocaleString(defiData.protocolTotals[protocol].total_assets[0])}</p>
                </div>
              </Link>
            );
          })
        : null}
    </div>
  );
};

export default TopL2Protocols;

